import { ContentType } from '@creditsights/api-ui-web';
import { Divider } from '@creditsights/styleguide-web';
import React, { ReactElement, useMemo } from 'react';
import { ROUTES } from '../../../Base.constants';
import { useGlobalModalContext } from '../../../components/GlobalModal';
import { MODAL_TYPES } from '../../../components/GlobalModal/GlobalModal';
import TruncatedLinkList from '../../../components/TruncatedLinkList';
import { Article } from '../../../models';
import { isReportSourceTag } from '../../../utils/tagUtils';
import { SEARCH_TERM_URL_KEY } from '../../SearchResults/SearchResults.constants';
import { HIDDEN_REPORT_SOURCE_TAGS } from './ArticleReportSources.constants';

export interface ArticleReportSourcesProps {
  article: Article;
  className?: string;
}

const ArticleReportSources = ({ article, className }: ArticleReportSourcesProps): ReactElement | null => {
  const { showModal } = useGlobalModalContext();
  const reportSourceLinks = useMemo(() => {
    if (article.articleType !== ContentType.News) {
      return [];
    }

    const resourceTags = article.tags.filter(
      (tag) => isReportSourceTag(tag.tagId) && !HIDDEN_REPORT_SOURCE_TAGS.includes(tag.tagId.toLowerCase())
    );
    return resourceTags.map((tag) => ({
      title: tag.name,
      url: `${ROUTES.search}?${SEARCH_TERM_URL_KEY}="${tag.name}"`,
    }));
  }, [article]);

  const handleClick = () => {
    showModal(MODAL_TYPES.LINK_LIST, { title: 'Report Sources', items: reportSourceLinks });
  };

  if (!reportSourceLinks.length) {
    return null;
  }

  return (
    <>
      <Divider vertical />
      <TruncatedLinkList className={className} items={reportSourceLinks} onClick={handleClick} />
    </>
  );
};

export default ArticleReportSources;
